import axios from 'axios'
import router from '../router'
import { mgop } from '@aligov/jssdk-mgop'
import { getToken, getXzqh } from '@/utils/utils'
// import { AUTH_FAIL } from '@/consts/const'
import Toast from '@components/common/toast'
const instance = axios.create()
// 为实例添加“请求”拦截
instance.interceptors.request.use(function (config) {
  // 设置token
  if (localStorage.getItem('token')) {
    config.headers.common['X-Token'] = localStorage.getItem('token')
  }
  // 所有 /common/ 接口的 url 都追加缓存的 xzqh 参数（缓存在应用入口写入，此处不实时解析 url）
  if (config.url && config.url.indexOf('/common/') > -1) {
    const xzqh = getXzqh()
    if (xzqh) {
      config.url += (config.url.indexOf('?') > -1 ? '&' : '?') + 'xzqh=' + encodeURIComponent(xzqh)
    }
  }
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
// 为实例添加“响应”拦截
instance.interceptors.response.use(function (response) {
  // console.log('interceptors.response:村上春树 ', response.data)
  // 拦截：权限校验
  // 1.判断token是否失效
  if (response.data && response.data.code === 401) {
    // 1.执行重新授权操作
    // console.log('00000')
    Toast.show({
      message: response.data.msg
      // type: 'warn'
    })

    localStorage.removeItem('token')
   // getToken()
     // location.reload()


   // router.replace('/')
    // 2.重新登录
    // wechatAuth_2_0({
    //   redirect_uri: window.location.href
    // })
  }
  //  else if (response.data && response.data.code === 500) {
  //   Toast.show({
  //     message: response.data.msg
  //     // type: 'warn'
  //   })
  // }
  return response
}, function (error) {
  return Promise.reject(error)
})
function createAPI (baseURL) {
  return function (conf) {
    conf = conf || {}
    return instance(Object.assign({}, {
      url: conf.url,
      baseURL: baseURL,
      method: conf.method
    }, conf.opts))
  }
}

function convertRESTAPI (url, opts) {
  if (!opts || !opts.path) return url

  const pathKeys = Object.keys(opts.path)

  pathKeys.forEach((key) => {
    const r = new RegExp('(:' + key + '|{' + key + '})', 'g')
    url = url.replace(r, opts.path[key])
  })

  return url
}

export {
  createAPI,
  convertRESTAPI
}



// WEBPACK FOOTER //
// ./src/api/util.js